import { z } from "zod";

export const PostStripePortalUpdateSessionBodyInputSchema = z.object({
  priceId: z.string(),
  numberOfSeats: z.number().int(),
});
export const PostStripePortalSessionBodyInputSchema = z.object({
  returnUrl: z.string().url(),
  update: PostStripePortalUpdateSessionBodyInputSchema.optional(),
  cancel: z.boolean().optional(),
});

export const PostStripePortalSessionOutputSchema = z.object({
  id: z.string(),
  url: z.string().nullish(),
});

export type StripePortalSessionInput = z.infer<typeof PostStripePortalSessionBodyInputSchema>;
export type StripePortalSessionOutput = z.infer<typeof PostStripePortalSessionOutputSchema>;
